module.exports = __webpack_public_path__ + "img/small-bissness-illustration.acfbd591.png";